import {
  Box,
  Grid,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import React from "react";
import MergersAcquisitionsVisual from "./Visual";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";
import CircularProgress from "@mui/material/CircularProgress";
import DataTable from "./DataTable";

const years = [2021];

export default function MergersAcquisitions() {
  const [data, setData] = React.useState([]);
  const [treemapData, setTreemapData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [yearValue, setyearValue] = React.useState(years[0]);

  async function getData({ yearValue }) {
    setLoading(true);
    const q = query(
      collection(db, "mergers-and-acquisitions"),
      where("year", "==", yearValue)
    );

    const allDocs = [];
    const sectors = new Set();

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      allDocs.push(doc.data());
      sectors.add(doc.data()["sectors"][0]);
    });

    setData(allDocs);

    const groupBySector = allDocs.reduce((group, sector) => {
      const { sectors } = sector;
      group[sectors] = group[sectors] ?? [];
      group[sectors].push(sector);
      return group;
    }, {});

    const axes = [];

    sectors.forEach((sector) => {
      const lenOfSector = groupBySector[sector].length;
      const finalValue = {
        x: sector,
        y: lenOfSector,
      };
      axes.push(finalValue);
    });
    setTreemapData(axes);
    setLoading(false);
  }

  React.useEffect(() => {
    getData({ yearValue: yearValue });
  }, [yearValue]);

  const handleYearChange = (event) => {
    setyearValue(event.target.value);
  };

  return loading ? (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        </Grid>
      </Grid>
    </>
  ) : (
    <Box>
      <Grid
        container
        sx={{ marginBottom: "10px" }}
        spacing={2}
      >
        <Grid item xs={12}>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="year-select-label">Year</InputLabel>
              <Select
                labelId="year-select-label"
                id="year-select"
                label="Year"
                value={yearValue}
                onChange={handleYearChange}
              >
                {years.map((yr) => {
                  return <MenuItem value={yr}>{yr}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12}>
          <MergersAcquisitionsVisual
            data={treemapData}
            name={`${yearValue} M&A Activity By Sector`}
          />
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: 3,
        }}
      />
      <Box>
        <Grid container>
          <Grid item xs={12}>
            <DataTable data={data} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
